export default {
    /**
     * Gitment
     */

    owner: 'UnableRegister', //Your GitHub ID,
    repo: 'UnableRegister.github.io', //The repo to store comments,
    oauth: {
        client_id: 'ed92c44580d1755ab297',//Your client ID,
        client_secret: '0525c1d365e878e7d7955c86ed4e394d7330091c',//Your client secret,
    }
}


// WEBPACK FOOTER //
// ./src/gitmentConfig.js